import { RootState } from "../store";

export const selectUserOwner = (state: RootState) => state.userOwner.data
export const selectUserOwnerLoading = (state: RootState) => state.userOwner.pending
export const selectUserProcessing = (state: RootState) => state.userOwner.isUserProcessing
export const selectUserOwnerError = (state: RootState) => state.userOwner.error